import {AbstractControl, ValidationErrors} from '@angular/forms';

export function fileValidator(maxSize: number, allowedTypes: string[]): (control: AbstractControl) => ValidationErrors | null {
  return (control: AbstractControl): ValidationErrors | null => {

    if (!control.value) {
      return null; // No file selected, let required validator handle it
    }

    const file = control.value as File;
    const fileSizeInMB = file.size / 1024 / 1024;
    const fileType = file.type;


    if (fileSizeInMB > maxSize) {
      return { maxSize: { actual: fileSizeInMB, max: maxSize } };
    }

    if (!allowedTypes.includes(fileType)) {
      return { fileType: { actual: fileType, allowed: allowedTypes } };
    }

    return null;
  };
}
